import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Wrapper } from "modules/theme";
import SettingsSidebar from "../../sidebar";
import { Alert, confirm } from "modules/theme";
import APIManager from "modules/common/apiManager";
import ComponentAddEdit from "./ComponentAddEdit";
import { Row, RowTitle, Box, BoxName, Divider } from "../../main/styles";
import { BarItems } from "modules/theme";
import { DataWrapperClass } from "../styles";
import { Dropdown, Modal } from "react-bootstrap";
import { FiTag, FiTrash2 } from "react-icons/fi";
import { PerPage } from "helpers/system-config";
import { FormWrapper, FormColumn } from "modules/theme";
import { ModalFooter } from "modules/theme";
import { MdOutlineAdd } from "react-icons/md";
import {
  ModalTrigger,
  Pagination,
  Button,
  FormControl,
  ActionButtons,
  Table,
  Label,
  Tip,
  DataWithLoader,
  FormGroup,
  ControlLabel,
  ReportPagination,
  DropdownToggle,
  SeachForm,
} from "modules/theme";
import { AiOutlineMore } from "react-icons/ai";
import { ManageColumns } from "modules/theme";
import { leftSidebarType, modalType } from "../../../../../helpers/dotenv";

const defaultColums = ["Name", "Config"];
class ComponentList extends Component {
  constructor(props) {
    super(props);
    this.moduleName = `Config`;
    this.moduleUrl = `tenant/config`;
    this.mAPI = new APIManager();
    this.handleModalShowHide = this.handleModalShowHide.bind(this);
    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.onPerPageChooser = this.onPerPageChooser.bind(this);
    this.getList = this.getList.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.search = this.search.bind(this);
    this.handleModalShowColumn = this.handleModalShowColumn.bind(this);
    let selectedColumList = defaultColums;
    this.state = {
      listData: [],
      total: 0,
      currentPage: 1,
      perPageCount: PerPage,
      loading: false,
      editData: null,
      showHide: false,
      modalType: modalType,
      MasterChecked: false,
      SingleChecked: false,
      SelectedList: [],
      ary: [],
      tagList: [],
      search: "",
      assignAry: [],
      tags: [],
      SelectedTagList: [],
      TagChecked: false,
      columnList: defaultColums,
      selectedColumList: selectedColumList,
      showColumnm: false,
    };
    this.getTag();
  }
  componentDidMount() {
    this.getList();
  }
  // breadcrumb(){
  //   return ;
  // }

  onMasterCheck(e) {
    let tempList = this.state.listData;
    // Check/ UnCheck All Items
    tempList.map((listData) => (listData.selected = e.target.checked));

    //Update State
    this.setState({
      MasterChecked: e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  handleModalShowColumn() {
    this.setState({ showColumnm: !this.state.showColumnm });
  }

  onItemCheck(e, item) {
    let tempList = this.state.listData;
    tempList.map((user) => {
      if (user._id === item._id) {
        user.selected = e.target.checked;
      }
      return user;
    });

    //To Control Master Checkbox State
    const totalItems = this.state.listData.length;
    const totalCheckedItems = tempList.filter((e) => e.selected).length;

    // Update State
    this.setState({
      // SingleChecked: e.target.checked,
      MasterChecked: totalItems === totalCheckedItems && e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  onItemTagCheck(e, item) {
    console.log("item", item);
    let tempList = this.state.tagList;
    tempList.map((tag) => {
      if (tag._id === item._id) {
        tag.selectedTag = e.target.checked;
      }
      return tag;
    });

    console.log(
      "filter",
      this.state.tagList.filter((e) => e.selectedTag)
    );
    this.setState({
      TagChecked: e.target.checked,
      tagList: tempList,
      SelectedTagList: this.state.tagList.filter((e) => e.selectedTag),
    });
    console.log("selectedTagList", this.state.SelectedTagList);
    // this.assignTag(e);
  }

  closeModal(isUpdated) {
    console.log("isUpdated", isUpdated);
    this.setState({ showHide: false });
    if (isUpdated) {
      this.getList(
        this.state.currentPage,
        this.state.perPageCount,
        this.state.search
      );
    }
  }
  openModal(data) {
    if (data) {
      this.setState({ showHide: true, editData: data });
    } else {
      this.setState({ showHide: true, editData: undefined });
    }
  }

  handleModalShowHide(data) {
    this.setState({ showHide: !this.state.showHide });
  }

  getList(page = 1, perPage = "", searchText = "") {
    var that = this;
    this.setState({ loading: true });
    perPage = perPage || this.state.perPageCount;
    this.mAPI.sendGetAPI(
      `${this.moduleUrl}?limit=${perPage}&page_no=${page}&search=${searchText}&orderBy=create_at&order=DESC`,
      (data) => {
        this.setState({ loading: false });
        console.log(JSON.stringify(data, null, 2));
        if (data && data.data) {
          that.setState({
            listData: data.data,
            total: data.count || 0,
            SelectedList: [],
            ary: [],
          });
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        if (data) {
          Alert.error(` ${data.message}`);
        } else {
          Alert.error(`${error}`);
        }
      }
    );
  }

  getTag() {
    var that = this;
    // this.setState({ loading: true });
    this.mAPI.sendGetAPI(
      `setting/tag?limit=10&page_no=1`,
      (data) => {
        // this.setState({ loading: false });
        console.log(JSON.stringify(data, null, 2));
        if (data && data.data) {
          that.setState({ tagList: data.data });
        } else {
          that.setState({ tagList: [] });
        }
        // console.log('ModuleName ', this.state.moduleNameList);
      },
      (error, data) => {
        console.log(`Error:`, error);
        // if (data) {
        //   Alert.success(`${data.message}`);
        // } else {
        //   Alert.error(`${error}`);
        // }
      }
    );
  }

  onPaginationChange(page) {
    console.log("onPaginationChange", page);
    this.setState({ currentPage: page });
    this.getList(page, this.state.perPageCount, this.state.search);
  }

  onPerPageChooser(perPage) {
    console.log("onPerPageChooser", perPage);
    this.setState({ currentPage: 1 });
    this.setState({ perPageCount: perPage });
    this.getList(1, perPage, this.state.search);
  }

  remove(array, key, value) {
    const index = array.findIndex((obj) => obj[key] === value);
    return index >= 0
      ? [...array.slice(0, index), ...array.slice(index + 1)]
      : array;
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  deleteData(data) {
    console.log("data", data);
    var that = this;
    this.mAPI.sendPostAPI(
      `${this.moduleUrl}/${data._id}`,
      undefined,
      (data) => {
        console.log(JSON.stringify(data, null, 2));
        let tD = that.state.listData;
        tD = that.remove(tD, "_id", data._id);
        that.setState({ listData: tD });
        this.getList(
          this.state.currentPage,
          this.state.perPageCount,
          this.state.search
        );
        Alert.success(`The ${this.moduleName} is deleted.`);
      },
      (errorCode, data) => {
        console.log(`Error: `, errorCode);
        console.log(`Data`, data);
        Alert.error(`errorCode : ${data.message}`);
      },
      "private",
      {},
      "DELETE"
    );
  }

  deleteAllData(e) {
    let _this = this;
    e.preventDefault();
    // const ary = [];
    const list = this.state.SelectedList.map((data) => {
      // ary = data._id;
      this.state.ary.push(data._id);
      // this.setState({ ary: data._id });
      console.log("data", this.state.ary);
    });
    this.mAPI.sendPostAPI(
      `${this.moduleUrl}/multiple/usingIds`,
      {
        ids: this.state.ary,
      },
      (data) => {
        console.log(JSON.stringify(data, null, 2));
        this.getList(
          this.state.currentPage,
          this.state.perPageCount,
          this.state.search
        );
        Alert.success(`${this.moduleName} is deleted.`);
      },
      (errorCode, data) => {
        console.log(`Error: `, errorCode);
        console.log(`Data`, data);
        Alert.error(`errorCode : ${data}`);
      },
      `private`,
      {},
      "PUT"
    );
  }

  assignTag(e) {
    const list = this.state.SelectedList.map((data) => {
      this.state.assignAry.push(data._id);
      // console.log('data',this.state.assignAry);
    });
    const tag = this.state.SelectedTagList.map((data) => {
      this.state.tags.push(data.name);
    });
    let tData = {
      module_ids: this.state.assignAry,
      module_name: this.moduleName,
      tags: this.state.tags,
    };
    this.mAPI.sendPostAPI(
      `setting/tag`,
      tData,
      (data) => {
        console.log(JSON.stringify(data, null, 2));
        // this.getList();
        // Alert.success(`All ${this.moduleName} is deleted.`);
      },
      (errorCode, data) => {
        console.log(`Error: `, errorCode);
        console.log(`Data`, data);
        Alert.error(`errorCode : ${data}`);
      },
      `private`,
      {},
      "PUT"
    );
  }

  onChange() {}

  onSingleChange(e, company) {}

  edit(data) {
    return (
      <Button
        btnStyle="link"
        onClick={() => this.openModal(data)}
        style={{ verticalAlign: "middle" }}
        icon="edit"
      ></Button>
    );
  }

  renderActions(data) {
    return (
      <ActionButtons>
        {this.edit(data)}
        <Tip text={`${"delete"}`} key={`${"delete"}`}>
          <Button
            btnStyle="link"
            onClick={(e) =>
              confirm().then((e) => {
                this.deleteData(data, e);
              })
            }
            style={{ verticalAlign: "middle" }}
            // icon={'user-minus'}
          >
            <FiTrash2 style={{ fontSize: "14px" }} />
          </Button>
        </Tip>
      </ActionButtons>
    );
  }

  moveCursorAtTheEnd(e) {
    const tmpValue = e.target.value;
    e.target.value = "";
    e.target.value = tmpValue;
    console.log("tmpValue", tmpValue);
  }

  search(e) {
    let teamList = this.state.listData;
    teamList.map((e) => (e.selected = false));
    this.setState({
      SelectedList: [],
      MasterChecked: false,
      SingleChecked: false,
      listData: teamList,
      currentPage: 1
    });
    let value;
    value = e.target.value;
    const reg = /^[a-zA-Z0-9_ @]*$/;
    if (reg.test(value)) {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        // search(value);
        this.setState({ search: value, currentPage: 1 });
        this.getList(1, this.state.perPageCount, value);
      }, 500);
    }
  }

  renderActionBar() {
    const { __ } = this.context;
    const importTrigger = (
      <Button btnStyle="default" size="small">
        {/* <MdOutlineAdd /> */}
        <img src="/images/plus.png" style={{ width: "12px" }} />
      </Button>
    );
    return (
      <span style={{ display: "flex", whiteSpace: "nowrap" }}>
        <SeachForm>
          <FormControl
            type="text"
            placeholder={"Search..."}
            onChange={(e) => this.search(e)}
            value={this.state.searchValue}
            autoFocus={false}
          />
        </SeachForm>
        {/* <FormControl
          type="text"
          placeholder={__('Type to search')}
          onChange={e => this.search(e)}
          value={this.state.searchValue}
          autoFocus
          onFocus={e => this.moveCursorAtTheEnd(e)}
          style={{ border: 'none' }}
        /> */}

        {/* <Button
          btnStyle="default"
          size="small"
          icon="add"
          onClick={() => this.handleModalShowColumn()}
          style={{ marginLeft: '10px' }}
        >
          Edit Column
        </Button> */}

        <Modal show={this.state.showColumnm} className="center" size="lg">
          <Modal.Body>
            <form>
              {/* <FormWrapper>
                <FormColumn>
                  {this.renderFormGroup('Bulk Upload Contact', {
                    defaultValue: '',
                    autoFocus: true,
                    componentClass: 'file',
                    type: 'file',
                    value: '',
                    accept: 'audio/mp3,audio/wav',
                    selectedFile: this.state.file,
                    onChange: e => {
                      if (e.target.files && e.target.files[0]) {
                        this.setState({ file: e.target.files[0] });
                      } else {
                        this.setState({ file: null });
                      }
                    },
                    id: 'file'
                  })}
                </FormColumn>
              </FormWrapper> */}
              <ManageColumns
                contentType="RawReport"
                config={this.state.selectedColumList}
                // save={save}
                fields={this.state.columnList}
              />

              {/* <ModalFooter>
                <Button
                  btnStyle="simple"
                  onClick={() => this.handleModalShowColumn()}
                  icon="cancel-1"
                  size="small"
                  style={{ marginRight: '10px' }}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  btnStyle="default"
                  // onClick={() => this.saveData()}
                  icon="checked-1"
                  size="small"
                >
                  Save
                </Button>
              </ModalFooter> */}
            </form>
          </Modal.Body>
        </Modal>

        <ModalTrigger
          title={this.moduleName}
          trigger={importTrigger}
          size="md"
          showHide={this.state.showHide}
          closeModal={this.closeModal}
          openModal={this.openModal}
          dialogClassName={this.state.modalType}
        >
          <ComponentAddEdit
            size="small"
            update={() => this.setState({ currentPage: 1 })}
            isEdit={false}
            ProviderList={this.state.ProviderList}
            TeamList={this.state.TeamList}
            UsersList={this.state.UsersList}
            editData={this.state.editData}
            modalType={this.state.modalType}
            closeModal={this.closeModal}
          />
        </ModalTrigger>
      </span>
    );
  }

  render() {
    const { __, theme } = this.context;
    console.log("theme", theme);
    const breadcrumb = [
      { title: __("Settings"), link: "/settings" },
      { title: __("Holiday"), link: "/settings/Holiday" },
    ];

    const mainContent = (
      <DataWrapperClass>
        <Table whiteSpace="nowrap" bordered hover>
          <thead>
            <tr>
              <th>
                <FormControl
                  componentClass="checkbox"
                  checked={this.state.MasterChecked}
                  onChange={(e) => this.onMasterCheck(e)}
                />
                {/* <input
                  type="checkbox"
                  className="form-check-input"
                  checked={this.state.MasterChecked}
                  id="mastercheck"
                  onChange={(e) => this.onMasterCheck(e)}
                /> */}
              </th>
              <th>{__("name")}</th>
              <th>{__("Actions")}</th>
            </tr>
          </thead>
          <tbody>
            {this.state.listData.map((data) => (
              <tr key={data._id}>
                <td onClick={this.onClick}>
                  <FormControl
                    componentClass="checkbox"
                    checked={data.selected}
                    onChange={(e) => this.onItemCheck(e, data)}
                  />
                  {/* <input
                    type="checkbox"
                    checked={data.selected}
                    className="form-check-input"
                    id="rowcheck{data.id}"
                    onChange={(e) => this.onItemCheck(e, data)}
                  /> */}
                </td>
                <td className="text-primary">{data.name}</td>
                <td>{this.renderActions(data)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </DataWrapperClass>
    );

    const actionBarRight = (
      <div>
        <BarItems>
          <Button
            btnStyle="default"
            onClick={() => this.handleModalShowHide()}
            icon="checked-1"
          >
            Add
          </Button>
        </BarItems>
      </div>
    );

    return (
      <DataWrapperClass>
        <Wrapper
          header={<Wrapper.Header breadcrumb={breadcrumb} />}
          actionBar={
            <Wrapper.ActionBar
              left={
                <div>
                  <ControlLabel>{this.moduleName}</ControlLabel>
                  {/* {console.log('masterchk', this.state.SelectedList)} */}
                  {this.state.SelectedList.length > 0 ? (
                    <Tip text={`${"Delete"}`} key={`${"Delete"}`}>
                      <Button
                        btnStyle="danger"
                        size="small"
                        onClick={(e) =>
                          confirm().then((e) => {
                            this.deleteAllData(e);
                          })
                        }
                        style={{ verticalAlign: "middle", marginLeft: "10px" }}
                        // icon={'user-minus'}
                      >
                        <FiTrash2
                          style={{ fontSize: "14px", marginBottom: "-3px" }}
                        />
                      </Button>
                    </Tip>
                  ) : (
                    ""
                  )}
                  {this.state.SelectedList.length === 1 ? (
                    <Dropdown id="dropdown-engage">
                      <DropdownToggle bsRole="toggle">
                        <Button
                          btnStyle="simple"
                          size="small"
                          style={{ marginLeft: "10px" }}
                        >
                          <FiTag
                            style={{ fontSize: "14px", marginBottom: "-3px" }}
                          />{" "}
                          Tag
                        </Button>
                      </DropdownToggle>
                      <Dropdown.Menu>
                        <li>
                          {/* <a>
                              {__('Edit')}
                            </a> */}
                          {/* {console.log('tag',this.state.tagList)} */}
                          {this.state.tagList.map((data) => (
                            <a
                            // onClick={e => (
                            //   this.assignTag(e)
                            // )}
                            >
                              <div>
                                <FormControl
                                  componentClass="checkbox"
                                  checked={data.selectedTag}
                                  onChange={(e) => this.onItemTagCheck(e, data)}
                                />
                                <FiTag
                                  style={{
                                    fontSize: "14px",
                                    marginBottom: "-3px",
                                    color: data.colourCode,
                                  }}
                                />{" "}
                                {data.name}
                              </div>
                            </a>
                          ))}
                        </li>
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : (
                    ""
                  )}
                </div>
              }
              // right={actionBarRight}
              right={this.renderActionBar()}
            />
          }
          footer={
            <ReportPagination
              count={this.state.total}
              onPaginationChange={this.onPaginationChange}
              onPerPageChooser={this.onPerPageChooser}
              currentPage={this.state.currentPage}
              perPage={this.state.perPageCount}
            />
          }
          leftSidebar={<SettingsSidebar />}
          showLeftSideBar={leftSidebarType}
          content={
            <div>
              <DataWithLoader
                data={mainContent}
                loading={this.state.loading}
                size={this.state.listData.length}
                count={this.state.listData.length}
                emptyText={`Add Your ${this.moduleName}`}
                emptyImage="/images/Holiday-empty.png"
              />
            </div>
          }
        />
      </DataWrapperClass>
    );
  }
}

ComponentList.contextTypes = {
  __: PropTypes.func,
  theme: PropTypes.string,
};

export default ComponentList;



// WEBPACK FOOTER //
// src/modules/screens/settings/Config/components/ComponentList.js